import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DataSharedService } from '../../services/data-shared.service';
import * as moment from 'moment';
import { ActiveContractorsService } from 'src/app/services/active-contractors.service';



@Component({
  selector: 'app-active-contractors',
  templateUrl: './active-contractors.component.html',
  styleUrls: ['./active-contractors.component.css']
})
export class ActiveContractorsComponent implements OnInit {


  public loading: boolean = false;
  public activeContractors: any = [];
  totalCount: number = 0;
  private modalRef: NgbModalRef;
  emailLogSearch: string = '';
  selectedMonth: string | null = null;
  selectedYear: number | null = null;
  years: number[] = [];
  months: any[] = [];
  constructor(
    public activeContractorsService: ActiveContractorsService,
    public dataSharedService: DataSharedService,) { }

  ngOnInit(): void {
    const now = moment();
    this.months = this.dataSharedService.getMonths();
    this.years = this.dataSharedService.getYears();
    this.selectedMonth = now.format('MM'); // Default to current month
    this.selectedYear = +now.format('YYYY'); // Default to current year
    this.getActiveContractors(1);
  }

  searchActiveContractors() {
    if (this.emailLogSearch != '') {
      this.getActiveContractors(1, this.emailLogSearch);
    } else {
      this.getActiveContractors(1);
    }
  }

  onStepChange(event: any) {
    this.getActiveContractors(event)
  }

  getActiveContractors(page: number, search?: string) {

    const params = {
      month: this.selectedMonth,
      year: this.selectedYear
    };

    this.activeContractorsService.getActiveContractors(params).subscribe((activeContractors: any) => {
      this.loading = false;
      this.activeContractors = activeContractors.data;
      console.log(this.activeContractors);
    });

  }

}
